import { Dispatch } from 'react-redux';
import * as types from './action-types';
import { AuthActionCreators, IApplicationState } from '../index';
import {
    IAdpDonor, IAdpCertificatePrintResponse, IAdpCertificateFileShareSiteLinks,
    IAdpVoucherHolderResponse, IAdpVoucherHolderRequest,
    IAdpBatchInfoResponse, IAdpBatchInfo, IBaseResponse, IUserIdResponse, IAdpVoucherHolderGetResponse, IAdpVoucherHolder, IAdpVoucherHolderCheckMissingPdfResponse, IListItem, IVoucherHolderForList
} from '@nkr/models/index';
import { IGet, IPost } from '../authorization';
import { AdpVoucherBatchType, AdpVoucherPrintStatus } from '@nkr/enums/index';

export interface IAdpDonorListResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            totalDonors: number,
            totalDonorsWithVoucherHolders: number,
            totalVoucherHolders: number,
            donors: IAdpDonor[]
        }
    }
}

export interface IVoucherHolderResponse {
    data: {
        success: boolean;
        message: string;
        results: IAdpVoucherHolder;
    }
}

export interface IVoucherHolderLookupDataResponse {
    data: {
        success: boolean;
        message: string;
        results: {
            aboTypeList: IListItem[],
            ckdStatusList: IListItem[],
            voucherHolderStatusList: IListItem[],
            voucherHolderTypeList: IListItem[],
            genderList: IListItem[],
            countryList: IListItem[]
        }
    }
}

export interface IVoucherHolderForListResponse {
    data: {
        success: boolean;
        message: string;
        results: {
            list: IVoucherHolderForList[],
            donorAlias: string
        }
    }
}

export interface IVoucherHolderFileUploadResponse {
    data: {
        success: boolean;
        message: string;
        results: string
    }
}

export interface IAddVoucherHolderResponse {
    data: {
        success: boolean;
        message: string;
        results: number
    }
}

export const ActionCreators = {
    getDonors: (firstName: string, lastName: string, email: string, alias: string, isAvailable: boolean, isNotAvailable: boolean) => (dispatch: Dispatch<IApplicationState>): Promise<IAdpDonorListResponse> => {
        let options = {
            url: `${__API__}/certificate/donor-voucher-holders`,
            data: {
                firstName,
                lastName,
                email,
                alias,
                isAvailable,
                isNotAvailable
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IAdpDonorListResponse) => {
            if (response.data.success)
                dispatch(ActionCreators.setAdpDonorList(response.data.results.donors));

            return Promise.resolve(response);
        });
    },
    printDonorCertificate: (donorIds: number[]) => (dispatch: Dispatch<IApplicationState>): Promise<IAdpCertificatePrintResponse> => {
        var options = {
            url: __API__ + "/certificate/print/donor",
            data: {
                ids: donorIds
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IAdpCertificatePrintResponse) => {
            if (response.data.success) {
                dispatch(ActionCreators.setAdpPrint(response.data.results));
            }

            return Promise.resolve(response);
        });
    },
    printVouchers: (voucherHolderIds: number[]) => (dispatch: Dispatch<IApplicationState>): Promise<IAdpCertificatePrintResponse> => {
        var options = {
            url: __API__ + "/certificate/print/voucher-holder",
            data: {
                ids: voucherHolderIds
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IAdpCertificatePrintResponse) => {
            if (response.data.success) {
                dispatch(ActionCreators.setAdpPrint(response.data.results));
            }

            return Promise.resolve(response);
        });
    },
    updateDonorPrintStatus: (donorId: number, printStatus: AdpVoucherPrintStatus) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + "/certificate/print-status/donor",
            data: {
                donorId: donorId,
                printStatus: printStatus
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });

    },
    updateVoucherHolderPrintStatus: (voucherHolderId: number, printStatus: AdpVoucherPrintStatus) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + "/certificate/print-status/voucher-holder",
            data: {
                voucherHolderId: voucherHolderId,
                printStatus: printStatus
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });

    },
    resetAll: () => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + "/certificate/reset-all",
            data: {}
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    getManifest: (url: string) => (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        var options = {
            url: __API__ + url
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IAdpDonorListResponse) => {
            return Promise.resolve(response);
        });
    },
    getBatches: () => (dispatch: Dispatch<IApplicationState>): Promise<IAdpBatchInfoResponse> => {
        var options = {
            url: __API__ + "/certificate/batch"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IAdpBatchInfoResponse) => {
            if (response.data.success)
                dispatch(ActionCreators.setAdpBatchInfoList(response.data.results));

            return Promise.resolve(response);
        });
    },
    // getUserId: () => (dispatch: Dispatch<IApplicationState>): Promise<IUserIdResponse> => {
    //     var options = {
    //         url: __API__ + "/certificate/user-id"
    //     };

    //     return dispatch(AuthActionCreators.apiGet(options)).then((response: IUserIdResponse) => {
    //         if (response.data.success)
    //             return Promise.resolve(response);
    //     });
    // },

    getVoucherHolders: () => (dispatch: Dispatch<IApplicationState>): Promise<IAdpVoucherHolderGetResponse> => {
        var options = {
            url: __API__ + "/voucher/voucher-holders"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IAdpVoucherHolderGetResponse) => {
            if (response.data.success)
                dispatch(ActionCreators.setAdpVoucherHolderList(response.data.results));

            return Promise.resolve(response);
        });
    },
    getVoucherHoldersByCenter: (centerId: number, donorId: number, isAvailable: boolean, firstName: string, lastName: string, alias: string, email: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IVoucherHolderForListResponse> => {
        var options = {
            url: __API__ + `/voucher/voucher-holders/by-center?centerId=${centerId}&donorId=${donorId}&isAvailable=${isAvailable}&firstName=${firstName}&lastName=${lastName}&alias=${alias}&email=${email}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getVoucherHolderById: (voucherHolderId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IVoucherHolderResponse> => {
        let options: IGet = {
            url: `${__API__}/voucher-holder/${voucherHolderId}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getVoucherHolderLookupData: () => async (dispatch: Dispatch<IApplicationState>): Promise<IVoucherHolderLookupDataResponse> => {
        let options: IGet = {
            url: `${__API__}/voucher-holder/lookup-data`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    getVoucherHolderScreeningResults: (voucherHolderId: number) => (dispatch: Dispatch<IApplicationState>) => {
        var options: IGet = {
            url: __API__ + `/voucher/voucher-holder/${voucherHolderId}/test-results`,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },
    updateVoucherHolderScreeningStatus: (voucherHolderId: number, isReviewed: boolean) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + `/voucher/voucher-holder/${voucherHolderId}?isReviewed=${isReviewed}`,
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });

    },
    sendAbnormalEmail: (voucherHolderId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + `/voucher/voucher-holder/${voucherHolderId}/send-abnormal-email`,
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    checkForMissingPdf: (voucherHolderIds: number[]) => (dispatch: Dispatch<IApplicationState>): Promise<IAdpVoucherHolderCheckMissingPdfResponse> => {
        var options = {
            url: __API__ + "/voucher/missing-pdfs",
            data: voucherHolderIds
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IAdpVoucherHolderCheckMissingPdfResponse) => {
            return Promise.resolve(response);
        });
    },
    printAll: (voucherHolderIds: number[]) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + "/voucher/print-all-post",
            data: voucherHolderIds
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IAdpVoucherHolderCheckMissingPdfResponse) => {
            return Promise.resolve(response);
        });
    },
    setAdpBatchInfoList: (list: IAdpBatchInfo[]) => {
        return {
            type: types.SET_ADPBATCHINFOLIST,
            list
        }
    },
    setAdpDonorList: (list: IAdpDonor[]) => {
        return {
            type: types.SET_ADPDONORS,
            list
        }
    },
    setAdpPrint: (links: IAdpCertificateFileShareSiteLinks) => {
        return {
            type: types.SET_ADPDONORS,
            links
        }
    },
    setAdpVoucherHolderList: (list: IAdpVoucherHolder[]) => {
        return {
            type: types.SET_ADPVOUCHERHOLDERLIST,
            list
        }
    },

    addVoucherHolder: (donorId: number, request: IAdpVoucherHolderRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IAddVoucherHolderResponse> => {
        let options = {
            url: `${__API__}/voucher-holder/${donorId}`,
            data: request
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    updateVoucherHolder: (id: number, request: IAdpVoucherHolderRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/voucher-holder/${id}`,
            data: request
        };

        return await dispatch(AuthActionCreators.apiPut(options));
    },

    uploadVoucherHolderConsentForm: (voucherHolderId: number, consentFile: File) => async (dispatch: Dispatch<IApplicationState>): Promise<IVoucherHolderFileUploadResponse> => {
        let formData = new FormData();
        formData.append('consentFile', consentFile);

        let options: IPost = {
            url: `${__API__}/voucher-holder/${voucherHolderId}/upload-consent`,
            data: formData
        };

        return await dispatch(AuthActionCreators.apiPostFormData(options));
    },
    uploadVoucherHolderSwabResults: (voucherHolderId: number, swabResultsFile: File) => async (dispatch: Dispatch<IApplicationState>): Promise<IVoucherHolderFileUploadResponse> => {
        let formData = new FormData();
        formData.append('swabResultsFile', swabResultsFile);

        let options: IPost = {
            url: `${__API__}/voucher-holder/${voucherHolderId}/upload-swab-results`,
            data: formData
        };

        return await dispatch(AuthActionCreators.apiPostFormData(options));
    },
    uploadVoucherHolderScreeningResults: (voucherHolderId: number, screeningResultsFile: File) => async (dispatch: Dispatch<IApplicationState>): Promise<IVoucherHolderFileUploadResponse> => {
        let formData = new FormData();
        formData.append('screeningResultsFile', screeningResultsFile);

        let options: IPost = {
            url: `${__API__}/voucher-holder/${voucherHolderId}/upload-screening-results`,
            data: formData
        };

        return await dispatch(AuthActionCreators.apiPostFormData(options));
    },
    orderHlaKit: (voucherHolderId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/voucher-holder/${voucherHolderId}/order-kit`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    reorderScreening: (voucherHolderId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/voucher-holder/${voucherHolderId}/reorder-labs-with-auth`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    activateVoucher: (voucherHolderId: number, centerId: number, alias: string, existingRecipientId: number, isNewRecipient: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/voucher-holder/${voucherHolderId}/activate`,
            data: {
                centerId,
                alias,
                existingRecipientId,
                isNewRecipient
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    downloadVoucherHolderDocument: (voucherHolderId: number, docType: number) => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let url = '';

        if (docType == 0) {
            url = `${__API__}/voucher-holder/${voucherHolderId}/voucher-consent`;
        }

        if (docType == 1) {
            url = `${__API__}/voucher-holder/${voucherHolderId}/voucher-swab-results`;
        }

        if (docType == 2) {
            url = `${__API__}/voucher-holder/${voucherHolderId}/voucher-screening-results`;
        }

        let options: IGet = {
            url,
            responseType: 'blob'
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    resendVoucherLink: (voucherHolderId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/voucher-holder/${voucherHolderId}/resend-self-registration-link`
        }

        return dispatch(AuthActionCreators.apiPost(options))
    },

    downloadBatchCsv: (batchInfo: IAdpBatchInfo) => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let options: IGet = {
            url: `${__API__}/certificate/batch/${batchInfo.id}/csv`,
            responseType: 'blob'
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    downloadBatchManifest: (batchInfo: IAdpBatchInfo) => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let options: IGet = {
            url: `${__API__}/certificate/batch/${batchInfo.id}/manifest`,
            responseType: 'blob'
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    downloadBatchPdf: (batchInfo: IAdpBatchInfo) => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let url = batchInfo.batchTypeId == AdpVoucherBatchType.VoucherHolder ? `${__API__}/certificate/batch/${batchInfo.id}/voucher-holder` : `${__API__}/certificate/batch/${batchInfo.id}/donor`;

        let options: IGet = {
            url,
            responseType: 'blob'
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    }
}
